import EventEmitter, { MessageFn as defaultMessageFnType } from '@utils/eventEmitter';

export enum ReportsEvents {
  SKILL_LEVEL_REPORT_COMPLETED = 'SKILL_LEVEL_REPORT_COMPLETED',
  SKILL_LEVEL_REPORT_FAILED = 'SKILL_LEVEL_REPORT_FAILED',
  PM_REPORT_COMPLETED = 'PM_REPORT_COMPLETED',
  PM_REPORT_FAILED = 'PM_REPORT_FAILED',
}

type ReportsEventEmitterType = {
  [ReportsEvents.SKILL_LEVEL_REPORT_COMPLETED]: {
    report_name: string;
    curriculum_id?: number;
    district_id?: number;
    course_id?: number;
    teacher_id?: number;
    course_ids?: number[];
    report_count?: number;
  };
  [ReportsEvents.SKILL_LEVEL_REPORT_FAILED]: {
    report_name: string;
    error: string;
  };
  [ReportsEvents.PM_REPORT_COMPLETED]: {
    report_name: string;
    district_id: number;
  };
  [ReportsEvents.PM_REPORT_FAILED]: {
    report_name: string;
    error: string;
  };
};

export type MessageFnType = defaultMessageFnType<ReportsEventEmitterType>;

const ReportsEventEmitter = new EventEmitter<ReportsEventEmitterType>();
export default ReportsEventEmitter;

